import Basket from "./Basket";
new Basket()